import axios from "axios";

class ProgramService {
  getProgram(filter, page, pageSize, search ) {

    let query = `program?${filter ? filter + '&' : ""}`
    if(page && pageSize){
      query = `program?${filter ? filter + '&' : ""}page=${page}&pageSize=${pageSize}`
    }
    if(search){
      query +=  `&name=${search}`
    }
    return axios.get(query);
  }

  getProgramInactive(page, pageSize, name) {
    let query = `program/list-inactive?page=${page}&pageSize=${pageSize}`;

    if(name){
      query += `&name=${name}`;
    }
    return axios.get(query);
  }

  getProgramDetail(id) {
    return axios.get(`program/details/${id}`);
  }

  getDataCampaing(id) {
    return axios.get(`program/short-description/${id}`);
  }

  getProgramVpn(id) {
    return axios.get(`/program/vpn/detail/${id}`);
  }

  getProgramVdpDetail(id) {
    let config = {
      headers: {
        Authorization: "",
      },
    };
    return axios.get(`program/exposed/${id}`, config);
  }

  getProgramList(page, pageSize, reward, type, period, nda, vpn, managed, credential, campaign, search) {
    let query = "";
    query += reward ? `&reward=${reward}` : "";
    query += type ? `&type=${type}` : "";
    query += period ? `&period=${period}` : "";
    query += nda ? `&nda=yes` : "";
    query += vpn ? `&vpn_required=yes` : "";
    query += managed ? `&managed=yes` : "";
    query += credential ? `&credential=yes` : "";
    query += campaign ? `&campaign=yes` : "";

    if(search){
      query += `&name=${search}`
    }
    return axios.get(
      `program/list/filter?page=${page}&pageSize=${pageSize}${query}`,
    );
  }

  getProgramBlackList(programID, page, pageSize, search) {
    let query = "";
    query += page ? `?page=${page}` : "";
    query += pageSize ? `&pageSize=${pageSize}` : "";
    query += search ? `&usernameOrEmail=${search}` : "";

    return axios.get(`program/${programID}/blacklist${query}`);
  }

  getProgramWhiteList(programID, page, pageSize, search) {
    let query = "";
    query += page ? `?page=${page}` : "";
    query += pageSize ? `&pageSize=${pageSize}` : "";
    query += search ? `&usernameOrEmail=${search}` : "";

    return axios.get(`program/${programID}/whitelist${query}`);
  }

  getProgramListVdp(page, pageSize, name, type, period) {
    let query = "";
    query += name ? `&name=${name}` : "";
    query += type ? `&type=${type}` : "";
    query += period ? `&period=${period}` : "";

    let config = {
      headers: {
        Authorization: "",
      },
    };
    return axios.get(
      `program/vdp-list?page=${page}&pageSize=${pageSize}${query}`,
      config,
    );
  }

  getProgramMetrics(id) {
    return axios.get(`program/response-metrics/${id}`);
  }

  getProgramUpdates(id) {
    return axios.get(`program/update-messages/${id}`);
  }

  postProgram(payload) {
    return axios.post(`program`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  postProgramUpdateMessage(payload, id) {
    return axios.post(`program/update-messages/${id}`, payload);
  }

  postPreferredLanguage(ln) {
    return axios.put(`account/language/${ln}`);
  }
  putProgram(payload, id) {
    return axios.put(`program/` + id, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  putSubscribe(id) {
    return axios.put(`program/subscribe/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
  deleteSubscribe(id) {
    return axios.delete(`program/subscribe/${id}`,{
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  postProgramCampaign(id, payload) {
    return axios.post(`program/campaign/` + id, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  putProgramCampaign(id) {
    return axios.put(`program/campaign/` + id);
  }

  getInvites(page, pageSize, payload) {
    return axios.get(
      `program/invites?page=${page}&pageSize=${pageSize}${payload}`,
    );
  }

  getCampaignHistory(page, pageSize, payload) {
    return axios.get(
      `program/campaigns/filter?page=${page}&pageSize=${pageSize}${payload}`,
    );
  }

  revokeInvitation(invitationId) {
    return axios.put(`program/invitation/revoke/${invitationId}`);
  }

  postInvites(payload) {
    return axios.post(`program/invite`, payload);
  }

  getInvitesStatus(page, pageSize, status) {
    return axios.get(
      `program/specialist/invitations?page=${page}&pageSize=${pageSize}&status=${status}`,
    );
  }

  getVpnGeneral(page, pageSize, programId, query) {
    return axios.get(
      `program/vpn/general?page=${page}&pageSize=${pageSize}&programId=${programId}${query}`,
    );
  }

  getVpnGeneralLog(page, pageSize, programId, query) {
    return axios.get(
      `program/vpn/access_log/general?page=${page}&pageSize=${pageSize}${
        programId ? "&programId=" + programId : ""
      }${query}`,
    );
  }

  getVpnAccessLog(userId, page, pageSize, date) {
    let query = "?page=1&pageSize=9999";

    if (page) {
      query = `?page=${page}&pageSize=${pageSize}${date}`;
    }
    return axios.get(`program/vpn/access_log/${userId}${query}`);
  }
  getcredentials(page, pageSize) {
    return axios.get(
      `program/vpn/credentials/?page=${page}&pageSize=${pageSize}`,
    );
  }

  putInvitesStatus(id, status) {
    return axios.put(`program/invite/${id}?status=${status}`);
  }

  putVpnHacker(programId, personId, action) {
    return axios.put(`program/vpn/${programId}/${action}/${personId}`);
  }

  putProgramStop(id) {
    return axios.put(`program/status/${id}`);
  }

  putProgramExpose(id) {
    return axios.put(`program/exposed/${id}`);
  }

  getAccessLists(id) {
    return axios.get(`program/${id}/access-lists`);
  }

  putAccessHacker(id, type, id_hacker) {
    return axios.put(`program/${id}/${type}/${id_hacker}`);
  }

  postNda(payload) {
    return axios.post(`program/nda`, payload);
  }

  getNda(id) {
    return axios.get(`program/nda/${id}`);
  }

  getNdaList() {
    return axios.get(`program/nda`);
  }

  getAcceptedNdaList(programId) {
    return axios.get(`program/accepted-nda/${programId}`);
  }

  acceptNda(programId) {
    return axios.put(`program/nda/${programId}`);
  }

  postBlacklist(payload) {
    return axios.post(`program/blacklist`, payload);
  }

  getInvitationsSummary() {
    return axios.get(`program/summary/invitations`);
  }
  postArchiveProgram(programId, payload) {
    return axios.post(`program/archive/${programId}`, payload);
  }
  getListProgramInvite() {
    return axios.get(`program/list/all`);
  }
}

export default new ProgramService();
